import {FormStorage} from "../../../../../resources/js/app/FormStorage";
import {JsonResponseError} from "../../../../../resources/js/app/JsonResponseError";

require('../../../../../resources/js/components/SplitPane');

export class DiabeticAssessmentForm
{
	form;

	/** @type SplitPane */
	splitPane;

	constructor()
	{
		// noinspection JSUnresolvedVariable
		this.form = document.forms.diabetic;
		if (!this.form)
			return;

		this.splitPane = SplitPane.get();
		this.setup();
	}

	setup()
	{
		$(this.form).on('submit', () => this.submit());

		var resolvePatientButton = $('#resolvePatientButton');
		resolvePatientButton.on('click', () => this.resolvePatientInNookal(resolvePatientButton.data('url')));

		let changePatientButton = $('#changePatientButton');
		changePatientButton.on('click', () =>
		{
			this.splitPane.sections.patientDetails
				.enableBody()
				.setNotValid();
			changePatientButton.fadeOut();
		});

		[
			'patientDetails',
			'diabeticRiskAssessment',
			'generalFootcareReview',
			'comments'
		].forEach((section) => this.splitPane.sections[section].allInputs().restoreFromStorage().enableStorage());
		$([
			this.form['vascularAssessment[palpablePedalPulses][]'],
			this.form['vascularAssessment[intermittentClaudication]'],
			this.form['orthopaedicAssessment[deformities][]'],
			this.form['ulcerAmputation[history]'],
		]).restoreFromStorage().enableStorage();

		$(this.form.confirmation).enableWhenChecked();
	}

	patientDetail(key, value)
	{
		let input = this.form['patientDetails[' + key + ']'];
		if (value)
		{
			input.value = value;
			FormStorage.store(input);
		}
		else
			return input.value;
	}

	resolvePatientInNookal(url)
	{
		ajaxGet(url.replace(':location_id', this.patientDetail('locationId')), {
			patient_id: this.patientDetail('patientId'),
			first_name: this.patientDetail('firstName'),
			last_name: this.patientDetail('lastName'),
			dob: this.patientDetail('dob'),
		}, (response) => this.handlePatientSearch(response));
	}

	/**
	 * @param {JsonResponse} response
	 */
	handlePatientSearch(response)
	{
		if (response.success && response.data.records.length === 0)
		{
			response.error = new JsonResponseError('No patient could be found.');
			response.success = false;
		}

		if (!response.showAlertIfError('Could Not Find Patient'))
		{
			/** @type NookalPatient[] */
			let patients = response.data.records;
			if (patients.length === 1)
				this.setPatient(patients[0], true);
		}
	}

	setPatient(patient, lock)
	{
		this.patientDetail('patientId', patient.id);
		this.patientDetail('firstName', patient.firstName);
		this.patientDetail('lastName', patient.lastName);
		this.patientDetail('dob', patient.dob);

		if (lock)
		{
			this.splitPane.sections.patientDetails
				.setValid()
				.disableBody();
			$('#changePatientButton').fadeIn();
		}
	}

	submit()
	{
		if (!this.validate())
			return false;

		try
		{
			ajaxPost(this.form.action, new FormData(this.form),
				(response) => this.handleResponse(response));
		}
		catch(e)
		{
			console.log(e);
		}
		return false;
	}

	validate()
	{
		return true;
	}

	/**
	 * @param {JsonResponse} response
	 */
	handleResponse(response)
	{
		response.showAlertIfError('Error Submitting Form');
	}
}

window.Modules = window.Modules || {};
window.Modules.DiabeticAssessmentForm = DiabeticAssessmentForm;
